/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */

import { BaseComponent } from '../../../../../core/components';
import { Component } from '@angular/core';
import { DownloadService, KeyStoreService, ModalService } from '../../../../../core/services';

@Component({
    selector: 'app-accounts-recover-keys',
    templateUrl: './accounts-recover-keys.component.html',
    styleUrls: ['./accounts-recover-keys.component.scss']
})

export class AccountsRecoverKeysComponent extends BaseComponent {
    /**
     * Store the name of the organisation key.
     */
    public orgKeyName: string = 'lbOrgPrivate.key';

    /**
     * Filename for key.
     */
    public privateKeyName: string = 'lbUserPrivate.key';

    /**
     * Disabled the org key if the user doesn't have one.
     */
    public orgKeyDisabled: boolean = false;

    constructor(
        private downloadService: DownloadService,
        private keyStoreService: KeyStoreService,
        private modalService: ModalService
    ) {
        super();

        if (!this.keyStoreService.orgPrivateKey || this.keyStoreService.orgPrivateKey === 'null') {
            this.orgKeyDisabled = true;
        }
    }

    /**
     * Download the key
     * @decryptedKey
     */
    public downloadKeyAndValidate(decryptedKey: { armor: () => BlobPart; }, keyName: string): void {
        this.downloadService.generateDownload(decryptedKey.armor(), keyName, { callBack: this.closePasswordModal.bind(this) });
    }

    /**
     * Close password modal callback.
     * @private
     */
    private closePasswordModal(): void {
        this.modalService.closeParentModalEmitter.next('confirm-password');
    }
}

